import Content from "../Content";
import ContentTypes from "../ContentTypes";

/**
* GiveItemContent.js
* 
* Created on 12-nov-2013
*
* @author Olivier van der Pool for Ranj
**/
export default class GiveItemContent extends Content {
        constructor(languagePack, contentID, itemID, label) {
            super(GiveItemContent.NAME, ContentTypes.TYPE_GIVE_ITEM, label, languagePack, contentID);   
            
            this._itemID = itemID;
        }

        getItemID() {
            return this._itemID;
        }

        setItemID(value) {
            this._itemID = value;
        }

        convertToObject() {
            return this.getObject(["itemID"]);
        }

        clone() {
            return new GiveItemContent(this._languagePack, this._contentID, this._itemID);
        }

        getDescriptionLabel() {
            return `Give '${this._itemID}'`;
        }
    }

    GiveItemContent.NAME = "Give Item";
    GiveItemContent.TYPE = "engGiveItem";

